import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Login from './components/Login';
import ParentActivation from './components/ParentActivation';
import Users from './components/Users';
import Students from './components/Students';
import Parents from './components/Parents';
import Fleet from './components/Fleet';
import Devices from './components/Devices';
import CreateDevices from './pages/CreateDevices';
import Rosters from './components/Rosters';
import Personnel from './components/Personnel';
import RoutesEngine from './pages/RoutesEngine';
import OptimizedRoutes from './components/OptimizedRoutes';
import Track from './components/Track';
import ProtectedRoute from './components/ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import MobileBlocker from './components/MobileBlocker';
import LoadingBar from './components/LoadingBar';
import CreateAdmin from './pages/CreateAdmin';
import Settings from './pages/Settings';
import ApiPollingManager from './components/ApiPollingManager';
import DashboardEntry from './components/DashboardEntry';
import MessagesPage from './components/MessagesPage';
import './index.css';

function App() {
  return (
    <MobileBlocker>
      <LoadingBar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/create-admin" element={<CreateAdmin />} />
        <Route path="/parent-activate" element={<ParentActivation />} />
        <Route
          path="/*"
          element={
            <div className="overflow-x-hidden" style={{ display: 'flex', minHeight: '100vh', background: '#f6f7fb' }}>
              <div className="sidebar-container">
                <Sidebar />
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <ApiPollingManager />
                <Topbar />
                <ProtectedRoute>
                  <Routes>
                    <Route path="/dashboard" element={<RoleProtectedRoute requiredModule="/dashboard"><DashboardEntry /></RoleProtectedRoute>} />
                    <Route path="/parent-dashboard" element={<RoleProtectedRoute requiredModule="/dashboard"><DashboardEntry /></RoleProtectedRoute>} />
                    <Route path="/users" element={<RoleProtectedRoute requiredModule="/users"><Users /></RoleProtectedRoute>} />
                    <Route path="/students" element={<RoleProtectedRoute requiredModule="/students"><Students /></RoleProtectedRoute>} />
                    <Route path="/parents" element={<RoleProtectedRoute requiredModule="/parents"><Parents /></RoleProtectedRoute>} />
                    <Route path="/fleet" element={<RoleProtectedRoute requiredModule="/fleet"><Fleet /></RoleProtectedRoute>} />
                    <Route path="/devices" element={<RoleProtectedRoute requiredModule="/devices"><Devices /></RoleProtectedRoute>} />
                    <Route path="/devices/create" element={<RoleProtectedRoute requiredModule="/devices"><CreateDevices /></RoleProtectedRoute>} />
                    <Route path="/roster" element={<RoleProtectedRoute requiredModule="/roster"><Rosters /></RoleProtectedRoute>} />
                    <Route path="/personnel" element={<RoleProtectedRoute requiredModule="/personnel"><Personnel /></RoleProtectedRoute>} />
                    <Route path="/track" element={<RoleProtectedRoute requiredModule="/track"><Track /></RoleProtectedRoute>} />
                    <Route path="/routes/engine" element={<RoleProtectedRoute requiredModule="/routes/engine"><RoutesEngine /></RoleProtectedRoute>} />
                    <Route path="/routes/optimized" element={<RoleProtectedRoute requiredModule="/routes/optimized"><OptimizedRoutes /></RoleProtectedRoute>} />
                    <Route path="/messages" element={<RoleProtectedRoute requiredModule="/messages"><MessagesPage /></RoleProtectedRoute>} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </ProtectedRoute>
              </div>
            </div>
          }
        />
      </Routes>
    </MobileBlocker>
  );
}

export default App; 